module.exports = "/boom/client/823a7eabbe9866a1ade50c779a6c0fcd.png";